export default __webpack_public_path__ + "static/media/ground-floor4.5937ba38.jpg";